/**
 * Cookie utility functions for managing browser cookies
 */

/**
 * Sets a cookie with the specified name, value, and expiration days
 */
export function setCookie(name: string, value: string, days: number): void {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
}

/**
 * Gets the value of a cookie by name
 */
export function getCookie(name: string): string | null {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  
  return null;
}

/**
 * Deletes a cookie by name
 */
export function deleteCookie(name: string): void {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
}

/**
 * Checks if the user has accepted cookies
 */
export function hasAcceptedCookies(): boolean {
  return getCookie('cookie-consent') === 'accepted';
}

/**
 * Marks that the user has accepted cookies
 */
export function acceptCookies(): void {
  // Set cookie for 365 days
  setCookie('cookie-consent', 'accepted', 365);
}